import React, { useEffect, useState } from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import image1 from "../../../Assets/Home/MainHome/home1.png";
import image2 from "../../../Assets/Home/MainHome/home2.png"
import image3 from "../../../Assets/Home/MainHome/home3.png"
import imageIcon from "../../../Assets/Home/MainHome/homeImageicon.png";
import { useNavigate } from "react-router-dom";
const MainHome = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showButtons, setShowButtons] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const slides = [
    {
      image: image1,
      tagline: "Handled with care",
      headings: ["Fast.", "Reliable.", "Next-Level Diagnostics."],
      description: "Welcome to our research laboratory center, where groundbreaking research meets practical applications. We bring together diverse expertise to tackle global issues."
    },
    {
      image: image2,
      tagline: "Delivered with trust",
      headings: ["Quick.", "Trusted.", "Advanced Diagnostics."],
      description: "Welcome to our innovation laboratory, where discovery drives real-world impact. We unite brilliant minds to solve today’s most pressing challenges."
    },
    {
      image: image3,
      tagline: "Crafted with precision",
      headings: ["Rapid.", "Reliable.", "Smart Diagnostics."],
      description: "Welcome to our scientific research hub, where creativity meets technology. Our team works together to address the challenges shaping our future."
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const isBottomPosition = currentSlide === 1;

  const displayButtons = isHovering || showButtons;

  useEffect(() => {
    let timeoutId;

    const handleScroll = () => {
      setShowButtons(true);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        setShowButtons(false);
      }, 2000);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);
  return (
    <div
      className="relative w-full md:h-[90vh] h-[95vh] overflow-hidden"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div className="absolute inset-0">
        {slides.map((slide, index) => (
          <img
            key={index}
            src={slide.image}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${index === currentSlide ? "opacity-100" : "opacity-0"
              }`}
            alt="home"
          />
        ))}
      </div>

      <div className="absolute inset-0 w-[70%] bg-gradient-to-r from-gray-50 via-gray-200 to-transparent"></div>


      <div
        className="relative z-10 md:px-10 px-6 text-white max-w-4xl transition-all duration-1000 flex flex-col items-start"
        style={{
          position: "absolute",
          left: 0,
          top: isBottomPosition ? "auto" : "50%",
          bottom: isBottomPosition ? "10%" : "auto",
          transform: isBottomPosition ? "none" : "translateY(-50%)",
          width: "100%",
          height: "auto",
        }}
      >
        <p className="text-lg font-medium mb-5 text-black">
          {slides[currentSlide].tagline}
        </p>
        <div className="mb-4">
          {slides[currentSlide].headings.map((heading, index) => (
            <h1
              key={index}
              className={`text-5xl md:text-7xl familjen-font font-bold mb-2 ${index < 2 ? "text-primaryColor" : "text-black"
                }`}
            >
              {heading}
              <img src={imageIcon} className="md:flex hidden absolute inset-10 pl-72" />
            </h1>
          ))}
        </div>
        <p className="text-sm md:text-[1rem] font-normal mb-5 leading-relaxed max-w-2xl text-[#5a5a5a]">
          {slides[currentSlide].description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <button onClick={() => { navigate('/about'); window.scrollTo(0, 0) }} className="px-8 py-3 bg-primaryColor text-white font-semibold rounded-md hover:bg-[#65d6ed] transition-colors">
            EXPLORE MORE
          </button>
          <button className="px-8 py-3 border-2 border-primaryColor text-primaryColor font-semibold rounded-md hover:bg-primaryColor hover:text-white transition-colors duration-300" onClick={() => { navigate("/contact"); window.scroll(0, 0) }}>
            CONTACT US
          </button>
        </div>
      </div>
      {/* Left Slider Button */}
      <div className={`absolute left-4 top-1/2 -translate-y-1/2 transition-opacity duration-300 z-20 ${displayButtons ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}>
        <button
          onClick={prevSlide}
          className="bg-primaryColor hover:bg-[#4fd8f3] p-3 rounded-full transition-colors text-white"
        >
          <MdChevronLeft size={20} />
        </button>
      </div>

      {/* Right Slider Button */}
      <div className={`absolute right-4 top-1/2 -translate-y-1/2 transition-opacity duration-300 z-20 ${displayButtons ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}>
        <button
          onClick={nextSlide}
          className="bg-primaryColor hover:bg-[#4fd8f3] p-3 rounded-full transition-colors text-white"
        >
          <MdChevronRight size={20} />
        </button>
      </div>
    </div>
  );
};

export default MainHome;